import { InputFieldV5 } from "components/form";

const INPUT_FIELDS = [
  {
    name: "email",
    group: "requestResetPassword",
    type: "email",
    icon: "fa fa-envelope",
    className: "input ",
    required: true,
    component: InputFieldV5,
  },
];

export { INPUT_FIELDS };
